const useMockdata = false;

async function fetchWithAbort(url:any, options = {}, timeout = 3000) {
  const controller = new AbortController();
  const signal = controller.signal;

  // 设置超时，超时后调用 abort
  const timeoutId = setTimeout(() => {
      controller.abort(); // 取消请求
  }, timeout);

  try {
      const response = await fetch(url, { ...options, signal });
      if (!response.ok) {
          throw new Error('网络响应不正常');
      }
      return response;
  } catch (error: any) {
      if (error?.name === 'AbortError') {
          console.error('请求被取消（超时）');
      } else {
          console.error('请求失败:', error?.message);
      }
  } finally {
      clearTimeout(timeoutId); // 清理超时
  }
}

const request = async (variables: any, query: any, callName: "qids" | "cms", mockResponse?: any, signal?: AbortSignal, timeout?: number) => {
  if (useMockdata && mockResponse) {
    return {
      status: 200,
      ...mockResponse.data
    };
  }
  try {
    const requestBody = {
      variables,
      query,
    };
    const options: any = {
      method: "POST",
      mode: "cors",
      credentials: "omit",
      referrerPolicy: "strict-origin-when-cross-origin",
      signal: signal,
      headers: {
        accept: "*/*",
        "accept-language": "en-us,en;q=0.9",
        "content-type": "application/json",
        "sec-fetch-dest": "empty",
        "sec-fetch-mode": "cors",
        "sec-fetch-site": "cross-site",
      },
      body: JSON.stringify(requestBody),
    };
    const uri = callName === "qids" ? window.globalConfig?.DATA_SOURCES?.QIDS_URI : window.globalConfig?.DATA_SOURCES?.CMS_URI;
    const response = useMockdata? await fetchWithAbort(uri, options, timeout) : await fetch(uri, options)
    const data = await response?.json();

    const { errors, data: graphQLData } = data;
    if (errors) {
      console.log(
        "GraphQL errors:",
        errors?.[0]?.message,
        response?.status,
        JSON.stringify(errors)
      );
      throw {
        message: errors?.[0]?.message,
        code: response?.status,
      };
    } else {
      return {
        status: response?.status,
        ...graphQLData,
      };
    }
  } catch (error) {
    console.log(error);
  }
};
export default request;
